// extracted by mini-css-extract-plugin
export default {"app-header":"Header_app-header__QYMvv"};